<template>
    <div class="header">
        <div class="headerTitle">
          <img class="logo hidden-xs-only" src="../assets/img/smlogo.png" alt="">
          <span class="title">{{$t('m.guild_system_title')}}</span>
          <span class="title hidden-sm-and-down">{{$store.state.userInfo.guildName?' - '+$store.state.userInfo.guildName:''}}</span>
        </div>
        <div class="userInfo">
          <img class="photo hidden-xs-only" :src="$store.state.userInfo.guildLogo?$store.state.userInfo.guildLogo:require('../assets/img/avatar.png')" alt="">
          <el-dropdown>
            <span class="el-dropdown-link">
              <span>{{$store.state.userInfo.userName}}</span><i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <router-link to="/guild/personal-center-page" v-if="!isApplyPage">
                <el-dropdown-item>{{$t('m.account')}}</el-dropdown-item>
              </router-link>
              <router-link to="/guild/my-guild-detail" v-if="!isApplyPage">
                <el-dropdown-item>{{$t('m.my_agency')}}</el-dropdown-item>
              </router-link>
              <el-dropdown-item :divided='!isApplyPage' @click.native="$store.commit('loginOut')">{{$t('m.logout')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
</template>
<script>
  export default {
    props:{
      isBigPage: {
        type: Boolean,
        default () {
          return true;
        }
      },
      isApplyPage:false,
    },
    data() {
      return {

      };
    },
    mounted() {},
    methods: {
      // loginOut(){
      //   console.log(111);
      //   this.$store.commit('loginOut')
      // }

    },
  };

</script>
<style scoped>
  .el-dropdown-link{
    font-size: 18px;
    color: #333;
    cursor: pointer;
  }
 .header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }
  .logo{
    font-size: 30px;
    width: 45px;
    height: 45px;
  }
  .title{
    font-size: 22px;
    padding: 0;
    margin: 0;
    display: inline-block;
    color: #008AFF;
  }
  .userInfo{
    display: flex;
    align-items: center;
  }
  .photo{
    width: 48px;
    height: 48px;
    border-radius: 50%;
    margin: 0 10px;
    /* border: 1px solid #eee; */
  }

  @media only screen and (max-width: 767px){
    .logo,.photo{
      width: 36px;
      height: 36px;
    }
    .title{
      font-size: 16px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/pageHead.vue